import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './components/filter/filter.component';
import { SharedModule } from '@shared/shared.module';
import { SharedFeaturesModule } from '@shared-features/shared-features.module';
import { OrganizationBusinessStatusFilterComponent } from './components/organization-business-status/organization-business-status.component';
import { ShipmentsFilterComponent } from './components/shipments-filter/shipments-filter.component';
import { InvoicesFilterComponent } from './components/invoices-filter/invoices-filter.component';
import { DeliveryNotesFilterComponent } from './components/delivery-notes-filter/delivery-notes-filter.component';
import { DriversFilterComponent } from './components/drivers-filter/drivers-filter.component';
import { TrucksReportFilterComponent } from './components/trucks-report-filter/trucks-report-filter.component';
import { EnumToArrayPipe } from '@shared/pipes/enum-to-array.pipe';
import { TransportationPaymentsShipmentsFilterComponent } from './components/transportation-payments-shipments-filter/transportation-payments-shipments-filter.component'
import { FilteringChipsComponent } from './components/filtering-chips/filtering-chips.component';
@NgModule({
  declarations: [
    FilterComponent,
    OrganizationBusinessStatusFilterComponent,
    ShipmentsFilterComponent,
    InvoicesFilterComponent,
    DeliveryNotesFilterComponent,
    DriversFilterComponent,
    TrucksReportFilterComponent,
    TransportationPaymentsShipmentsFilterComponent,
    FilteringChipsComponent
  ],
  imports: [CommonModule, SharedModule, SharedFeaturesModule],
  exports: [FilterComponent, FilteringChipsComponent],
  providers: [EnumToArrayPipe]
})
export class FilterModule {}
